import { setUsrAppRefreshParams } from '@jfs/network'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { applySnapshot, flow, Instance, types } from 'mobx-state-tree'
import Config from 'react-native-config'
import { ToastPosition } from '../../comps/Toast'
import { appAuthGenerate, appAuthVerify } from '../../network/AppAuthPkce'
import { AppExpireReq } from '../../network/AppExpireReq'
import { appExtendSessionReq } from '../../network/appExtendSessionReq'
import { AppHeaderTransformer, extendAppSession } from '../../network/extendAppSession'
import { extendUserSession, HeaderTransformer } from '../../network/extendUserSession'
import { loginReq, userAuthApi } from '../../network/loginReq'
import { logoutRequest } from '../../network/logoutRequest'
import { getAuthenticateOtpRequest, getSendOtpRequest, otpLoginReq } from '../../network/otpLoginRequest'
import { reAuthSession } from '../../network/reAuthSession'
import { userExtendSessionReq } from '../../network/userExtendSessionReq'
import { verifyCred } from '../../network/verifyCred'
import {
  clearSession,
  getErrorMsg,
  getFromStore,
  isOsMobile,
  NotificationServiceModule,
  pkceGetCodeVerifier,
  removeDataFromStorage,
  storeData,
} from '../../util/util'
import {
  getAppExpireRequestBody,
  getAppExtendSessionBody,
  getAppLoginRequestBody,
  getLoginRequestBody,
  getSendOtpWithEmailReq,
  getSessionValidateRequestBody,
  getUserExtendSessionBody,
  getValidateEmailOtpReq,
} from '../request/requestbody'
import { customError } from '../static/strings'
import { RootStore } from '../store'
import { usrSessionRefreshConfig } from './../../network/config'

const REACT_APP_PKCE_ENABLED = isOsMobile()
  ? Config.REACT_APP_PKCE_ENABLED
  : window?._env_?.REACT_APP_PKCE_ENABLED ?? ''
export const DUMMY_MOBILE = '1234567890'

const Session = types
  .model('Session', {
    isVerified: types.optional(types.boolean, false), // To show otp
    lastLoginDate: types.optional(types.string, ''),

    appAccessToken: types.optional(types.string, ''), //app auth AccessToken
    appRefreshToken: types.optional(types.string, ''), //app auth RefreshToken
    appAccessTokenExpiry: types.optional(types.number, -1), //app auth AccessToken expiry
    appRefreshTokenExpiry: types.optional(types.number, -1), //app auth RefreshToken expiry
    appIdToken: types.optional(types.string, ''),

    userAccessToken: types.optional(types.string, ''),
    userIdToken: types.optional(types.string, ''),
    userAccessTokenExpiry: types.optional(types.number, -1), // user auth AccessToken expiry
    userRefreshTokenExpiry: types.optional(types.number, -1), // user auth RefreshToken expiry
    userRefreshToken: types.optional(types.string, ''), //user auth RefreshToken

    jfsUserId: types.optional(types.string, ''),

    authorizationCode: types.optional(types.string, ''),
    mobileNumber: types.optional(types.string, ''),
    emailId: types.optional(types.string, ''),
    isEmailLogin: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    updateToken(userAccessToken: string): void {
      self.userAccessToken = userAccessToken
    },
    setIsEmailLogin(isEmailLogin: boolean): void {
      self.isEmailLogin = isEmailLogin
    },
    setSessionVerified(isUserVerified: boolean): void {
      self.isVerified = isUserVerified
    },
    logout: flow(function* logout() {
      try {
        yield logoutRequest(getSessionValidateRequestBody(self), RootStore.user.session.getTokens)
        yield AppExpireReq(getAppExpireRequestBody(self), RootStore.user.session.getTokens)
        yield RootStore?.user?.session?.removeMerchantDetailsFromStore()
      } catch (error) {
        throw new Error(error?.message ?? 'Error while processing logout request')
      } finally {
        if (isOsMobile()) {
          NotificationServiceModule?.setSessionToNative('')
          AsyncStorage.multiRemove(['sessionData', 'enableLockLater', 'lockEnabled', 'fcmToken', 'voiceBoxInfo'])
        } else {
          clearSession()
        }
        RootStore.user.session.updateAppSessionData('', '', -1, -1, '')
        RootStore.user.session.updateUserSessionData('', '', '', -1, -1, '')
        RootStore.settings.metaData.updateSelectedMercName('')
        RootStore.settings.metaData.setAppLockEnabled(false)
        RootStore.settings.metaData.setAppLockLater(false)
        RootStore.user.updateSelectedMercMid('')
      }
    }),
    sendOtpAync: flow(function* sendOtpAync(emailId: string, _shouldAppAuth = true) {
      let response
      try {
        if (_shouldAppAuth) {
          if (isOsMobile() && !!REACT_APP_PKCE_ENABLED) {
            const codeVerifier = pkceGetCodeVerifier(64)
            let resAppAuthGen = yield appAuthGenerate(codeVerifier.toString(), RootStore.user.session.getTokens)
            if (resAppAuthGen?.status === 'SUCCESS' && resAppAuthGen?.authorizationCode?.length > 0) {
              self.authorizationCode = resAppAuthGen?.authorizationCode
              let resAppAuthVerify = yield appAuthVerify(
                self.authorizationCode,
                codeVerifier.toString(),
                RootStore.user.session.getTokens,
              )
              if (resAppAuthVerify.status === 'SUCCESS') {
                self.appAccessToken = resAppAuthVerify?.session?.accessToken?.tokenValue ?? ''
                self.appRefreshToken = resAppAuthVerify?.session?.refreshToken?.tokenValue ?? ''
                self.appIdToken = resAppAuthVerify?.session?.appIdentifierToken ?? ''
                self.appAccessTokenExpiry = resAppAuthVerify?.session?.accessToken?.expiresIn ?? -1
                self.appRefreshTokenExpiry = resAppAuthVerify?.session?.refreshToken?.expiresIn ?? -1
              }
            }
          } else {
            let responseAppAuth = yield verifyCred(
              getAppLoginRequestBody(DUMMY_MOBILE),
              RootStore.user.session.getTokens,
            )
            if (responseAppAuth.status === 'SUCCESS') {
              self.appAccessToken = responseAppAuth?.session?.accessToken?.tokenValue ?? ''
              self.appRefreshToken = responseAppAuth?.session?.refreshToken?.tokenValue ?? ''
              self.appIdToken = responseAppAuth?.session?.appIdentifierToken ?? ''
              self.appAccessTokenExpiry = responseAppAuth?.session?.accessToken?.expiresIn ?? -1
              self.appRefreshTokenExpiry = responseAppAuth?.session?.refreshToken?.expiresIn ?? -1
            }
          }
        }

        response = yield userAuthApi(getSendOtpWithEmailReq(emailId), RootStore.user.session.getTokens)
        const customToast = {
          color: 'GREEN',
          message: 'OTP has been sent successfully.',
          position: ToastPosition.BOTTOM,
        }
        RootStore.response.setCustomToast(customToast)
        console.log('htag resp=', response)
      } catch (e) {
        console.log('login error', e)
        const error = e?.data?.error
        const mapErrorMessage = getErrorMsg(error?.code, error?.message) ?? customError.errorOccured
        RootStore?.response?.setMessage(mapErrorMessage)
        throw getErrorMsg(error?.code, error?.message)
      }
      return response
    }),
    resendOtpAync: flow(function* resendOtpAync(emailId: string) {
      let response
      try {
        response = yield userAuthApi(getSendOtpWithEmailReq(emailId), RootStore.user.session.getTokens)
        console.log('htag resp=', response)
        const customToast = {
          color: 'GREEN',
          message: 'OTP has been resent successfully.',
          position: ToastPosition.BOTTOM,
        }
        RootStore.response.setCustomToast(customToast)
      } catch (e) {
        console.log('login error', e)
        const error = e?.data?.error
        const mapErrorMessage = getErrorMsg(error?.code, error?.message) ?? customError.errorOccured
        RootStore?.response?.setMessage(mapErrorMessage)
        throw getErrorMsg(error?.code, error?.message)
      }
      return response
    }),
    validateOtpAync: flow(function* validateOtpAync(emailId: string, otp: string) {
      let response
      try {
        response = yield userAuthApi(
          getValidateEmailOtpReq(emailId, otp, DUMMY_MOBILE),
          RootStore.user.session.getTokens,
        )
        console.log('htag resp=', response)
        self.mobileNumber = DUMMY_MOBILE
        self.emailId = emailId
        self.jfsUserId = response?.jfsUserId ?? ''
        self.userAccessToken = response?.session?.accessToken?.tokenValue
        self.userRefreshToken = response?.session?.refreshToken?.tokenValue
        self.userIdToken = response?.session?.identifierToken ?? ''
        self.userAccessTokenExpiry = response?.session?.accessToken?.expiresIn
        self.userRefreshTokenExpiry = response?.session?.refreshToken?.expiresIn
        self.isVerified = true
        self.lastLoginDate = ''
        storeData('sessionData', JSON.stringify(self))
        storeData('jfsUserId', response?.jfsUserId ?? '')
        window?.localStorage && window?.localStorage.setItem('sessionData', JSON.stringify(self))
        window?.localStorage && window?.localStorage.setItem('jfsUserId', response?.jfsUserId)
        window?.localStorage && window?.localStorage.setItem('userEmailId', emailId)
        //RootStore.settings.metaData.updateMobileNumber(username)*/
      } catch (e) {
        console.log('login error', e)
        const error = e?.data?.error
        const mapErrorMessage = getErrorMsg(error?.code, error?.message) ?? customError.errorOccured
        RootStore?.response?.setMessage(mapErrorMessage)
        throw getErrorMsg(error?.code, error?.message)
      }
      return response
    }),
    verifyCredentials: flow(function* verifyCredentials(username: string, password: string, _shouldAppAuth = true) {
      let response
      try {
        if (_shouldAppAuth) {
          if (isOsMobile() && !!REACT_APP_PKCE_ENABLED) {
            const codeVerifier = pkceGetCodeVerifier(64)
            let resAppAuthGen = yield appAuthGenerate(codeVerifier.toString(), RootStore.user.session.getTokens)
            if (resAppAuthGen?.status === 'SUCCESS' && resAppAuthGen?.authorizationCode?.length > 0) {
              self.authorizationCode = resAppAuthGen?.authorizationCode
              let resAppAuthVerify = yield appAuthVerify(
                self.authorizationCode,
                codeVerifier.toString(),
                RootStore.user.session.getTokens,
              )
              if (resAppAuthVerify.status === 'SUCCESS') {
                self.appAccessToken = resAppAuthVerify?.session?.accessToken?.tokenValue ?? ''
                self.appRefreshToken = resAppAuthVerify?.session?.refreshToken?.tokenValue ?? ''
                self.appIdToken = resAppAuthVerify?.session?.appIdentifierToken ?? ''
                self.appAccessTokenExpiry = resAppAuthVerify?.session?.accessToken?.expiresIn ?? -1
                self.appRefreshTokenExpiry = resAppAuthVerify?.session?.refreshToken?.expiresIn ?? -1
              }
            }
          } else {
            let responseAppAuth = yield verifyCred(getAppLoginRequestBody(username), RootStore.user.session.getTokens)
            if (responseAppAuth.status === 'SUCCESS') {
              self.appAccessToken = responseAppAuth?.session?.accessToken?.tokenValue ?? ''
              self.appRefreshToken = responseAppAuth?.session?.refreshToken?.tokenValue ?? ''
              self.appIdToken = responseAppAuth?.session?.appIdentifierToken ?? ''
              self.appAccessTokenExpiry = responseAppAuth?.session?.accessToken?.expiresIn ?? -1
              self.appRefreshTokenExpiry = responseAppAuth?.session?.refreshToken?.expiresIn ?? -1
            }
          }
        }
        response = yield loginReq(getLoginRequestBody(username, password), RootStore.user.session.getTokens)
        self.mobileNumber = username
        const parsedData = response
        self.jfsUserId = parsedData?.jfsUserId ?? ''
        self.userAccessToken = parsedData?.accessToken
        self.userRefreshToken = parsedData?.refreshToken ?? ''
        self.userIdToken = parsedData?.idToken ?? ''
        self.userAccessTokenExpiry = parsedData?.accessTokenExpiry
        self.userRefreshTokenExpiry = parsedData?.refreshTokenExpiry
        self.isVerified = true
        self.lastLoginDate = ''
        storeData('sessionData', JSON.stringify(self))
        storeData('jfsUserId', parsedData?.jfsUserId ?? '')
        window?.localStorage && window?.localStorage.setItem('sessionData', JSON.stringify(self))
        window?.localStorage && window?.localStorage.setItem('jfsUserId', parsedData?.jfsUserId)
        RootStore.settings.metaData.updateMobileNumber(username)
      } catch (e) {
        console.log('login error', e)
        const error = e?.data?.error
        const mapErrorMessage = getErrorMsg(error?.code, error?.message) ?? customError.errorOccured
        RootStore?.response?.setMessage(mapErrorMessage)
        throw getErrorMsg(error?.code, error?.message)
      }
      return response
    }),
    sendOtpAsync: flow(function* sendOtpAsync(mobileNumber) {
      try {
        if (isOsMobile() && !!REACT_APP_PKCE_ENABLED) {
          const codeVerifier = pkceGetCodeVerifier(64)
          let resAppAuthGen = yield appAuthGenerate(codeVerifier.toString(), RootStore.user.session.getTokens)
          if (resAppAuthGen?.status === 'SUCCESS' && resAppAuthGen?.authorizationCode?.length > 0) {
            self.authorizationCode = resAppAuthGen?.authorizationCode
            let resAppAuthVerify = yield appAuthVerify(
              self.authorizationCode,
              codeVerifier.toString(),
              RootStore.user.session.getTokens,
            )
            if (resAppAuthVerify.status === 'SUCCESS') {
              self.appAccessToken = resAppAuthVerify?.session?.accessToken?.tokenValue ?? ''
              self.appRefreshToken = resAppAuthVerify?.session?.refreshToken?.tokenValue ?? ''
              self.appIdToken = resAppAuthVerify?.session?.appIdentifierToken ?? ''
              self.appAccessTokenExpiry = resAppAuthVerify?.session?.accessToken?.expiresIn ?? -1
              self.appRefreshTokenExpiry = resAppAuthVerify?.session?.refreshToken?.expiresIn ?? -1
            }
          }
        } else {
          let responseAppAuth = yield verifyCred(getAppLoginRequestBody(mobileNumber), RootStore.user.session.getTokens)
          if (responseAppAuth.status === 'SUCCESS') {
            self.appAccessToken = responseAppAuth?.session?.accessToken?.tokenValue ?? ''
            self.appRefreshToken = responseAppAuth?.session?.refreshToken?.tokenValue ?? ''
            self.appIdToken = responseAppAuth?.session?.appIdentifierToken ?? ''
            self.appAccessTokenExpiry = responseAppAuth?.session?.accessToken?.expiresIn ?? -1
            self.appRefreshTokenExpiry = responseAppAuth?.session?.refreshToken?.expiresIn ?? -1
          }
        }
        const response = yield otpLoginReq(getSendOtpRequest(mobileNumber), RootStore.user.session.getTokens)
        return response
      } catch (e) {
        console.log('login error', e)
        const error = e?.data?.error
        const mapErrorMessage = getErrorMsg(error?.code, error?.message) ?? customError.errorOccured
        RootStore?.response?.setMessage(mapErrorMessage)
        throw getErrorMsg(error?.code, error?.message)
      }
    }),
    validateOtpAsync: flow(function* validateOtpAsync({ mobileNumber, otp }) {
      try {
        const response = yield loginReq(getAuthenticateOtpRequest(mobileNumber, otp), RootStore.user.session.getTokens)
        self.mobileNumber = mobileNumber
        const parsedData = response
        self.jfsUserId = parsedData?.jfsUserId ?? ''
        self.userAccessToken = parsedData?.accessToken
        self.userRefreshToken = parsedData?.refreshToken ?? ''
        self.userIdToken = parsedData?.idToken ?? ''
        self.userAccessTokenExpiry = parsedData?.accessTokenExpiry
        self.userRefreshTokenExpiry = parsedData?.refreshTokenExpiry
        self.isVerified = true
        self.lastLoginDate = ''
        storeData('sessionData', JSON.stringify(self))
        storeData('jfsUserId', parsedData?.jfsUserId ?? '')
        window?.localStorage && window?.localStorage.setItem('sessionData', JSON.stringify(self))
        window?.localStorage && window?.localStorage.setItem('jfsUserId', parsedData?.jfsUserId)
        RootStore.settings.metaData.updateMobileNumber(mobileNumber)
      } catch (e) {
        const error = e?.data?.error
        const mapErrorMessage = getErrorMsg(error?.code, error?.message) ?? customError.errorOccured
        RootStore?.response?.setMessage(mapErrorMessage)
        throw getErrorMsg(error?.code, error?.message)
      }
    }),
    resendOtpAsync: flow(function* resendOtpAsync(mobileNo: any) {
      try {
        const response = yield otpLoginReq(getSendOtpRequest(mobileNo), RootStore.user.session.getTokens)
        const customToast = {
          color: 'GREEN',
          message: 'OTP has been resent successfully!',
          position: ToastPosition.BOTTOM,
        }
        RootStore?.response?.setCustomToast(customToast)
        return response
      } catch (error) {
        RootStore?.response?.setMessage(error.message)
        throw error
      }
    }),
    resetAccessToken(): void {
      self.userAccessToken = ''
      self.userIdToken = ''
      self.isVerified = false
      self.lastLoginDate = new Date(1970, 1, 1).toUTCString()
    },

    reauthenticateSession: flow(function* reauthenticateSession() {
      const obj = { ...self }
      try {
        const response = yield reAuthSession(RootStore.user.session.getTokens)
        const { status, token } = response
        obj.userAccessToken = token
        applySnapshot(self, obj)
        storeData('sessionData', JSON.stringify(self))
        return status
      } catch (error) {
        // RootStore?.response?.setMessage(error?.data?.error?.message ?? customError.errorOccured)
        throw error
      }
    }),

    appExtendSession: flow(function* appExtendSession() {
      let resp
      try {
        resp = yield appExtendSessionReq(
          getAppExtendSessionBody(RootStore.user.session),
          RootStore.user.session.getTokens,
        )
        if (resp.status === 'SUCCESS') {
          const { data } = resp
          const { session } = data
          yield RootStore.user.session.updateAppSessionData(
            session?.accessToken?.tokenValue,
            session?.refreshToken?.tokenValue,
            session?.accessToken?.expiresIn,
            session?.refreshToken?.expiresIn,
            session?.appIdentifierToken,
          )
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
      }
      return resp
    }),
    userExtendSession: flow(function* userExtendSession(mobileNumber: string) {
      let number = mobileNumber || RootStore.settings.metaData.mobileNumber
      let resp
      try {
        resp = yield userExtendSessionReq(
          usrSessionRefreshConfig(RootStore.user.session.appAccessToken, RootStore.user.session.appIdToken),
          getUserExtendSessionBody(number, self),
        )
        if (resp.status === 'SUCCESS') {
          const { data } = resp
          const { session } = data
          RootStore.user.session.updateUserSessionData(
            session?.refreshToken?.tokenValue,
            session?.identifierToken,
            session?.accessToken?.tokenValue,
            session?.accessToken?.expiresIn,
            session?.refreshToken?.expiresIn,
          )
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
      }
      return resp
    }),

    setSessionTimer(time: number) {
      self.userAccessTokenExpiry = time ?? -1
    },
    setAppSessionTimer(time: number) {
      self.appAccessTokenExpiry = time ?? -1
    },
    updateEmailId(emailId: string) {
      self.emailId = emailId
    },
    updateUserSessionData: flow(function* updateUserSessionData(
      refreshToken: string,
      identifierToken: string,
      accessToken: string,
      accessTokenExpiresIn: number,
      refreshTokenExpiresIn: number,
      jfsUserId: string,
    ) {
      self.userAccessToken = accessToken
      self.userRefreshToken = refreshToken
      self.userRefreshTokenExpiry = refreshTokenExpiresIn
      self.userAccessTokenExpiry = accessTokenExpiresIn
      self.userIdToken = identifierToken
      self.jfsUserId = jfsUserId
      if (accessToken) {
        const mobileNumber = RootStore.settings.metaData.mobileNumber
        setUsrAppRefreshParams(
          extendUserSession(mobileNumber, self.userAccessToken, self.userRefreshToken),
          HeaderTransformer,
          extendAppSession(self.appAccessToken, self.appRefreshToken),
          AppHeaderTransformer,
        )
        yield storeData('sessionData', JSON.stringify(self))
        yield storeData('jfsUserId', jfsUserId)
        window?.localStorage && window?.localStorage.setItem('jfsUserId', jfsUserId)
        window?.localStorage && window?.localStorage.setItem('sessionData', JSON.stringify(self))
      } else {
        yield removeDataFromStorage('sessionData')
        yield removeDataFromStorage('jfsUserId')
        window?.localStorage && window?.localStorage.removeItem('jfsUserId')
        window?.localStorage && window?.localStorage.removeItem('sessionData')
      }
    }),
    updateAppSessionData: flow(function* updateAppSessionData(
      appAccessToken: string,
      appRefreshToken: string,
      appAccessTokenExpiry: number,
      appRefreshTokenExpiry: number,
      appIdentifierToken: string,
    ) {
      self.appAccessToken = appAccessToken
      self.appRefreshToken = appRefreshToken
      self.appAccessTokenExpiry = appAccessTokenExpiry
      self.appRefreshTokenExpiry = appRefreshTokenExpiry
      self.appIdToken = appIdentifierToken
      if (appAccessToken) {
        const mobileNumber = RootStore.settings.metaData.mobileNumber
        setUsrAppRefreshParams(
          extendUserSession(mobileNumber, self.userAccessToken, self.userRefreshToken),
          HeaderTransformer,
          extendAppSession(self.appAccessToken, self.appRefreshToken),
          AppHeaderTransformer,
        )
        yield storeData('sessionData', JSON.stringify(self))
        window?.localStorage && window?.localStorage.setItem('sessionData', JSON.stringify(self))
      } else {
        yield removeDataFromStorage('sessionData')
        yield removeDataFromStorage('jfsUserId')
        window?.localStorage && window?.localStorage.removeItem('jfsUserId')
        window?.localStorage && window?.localStorage.removeItem('sessionData')
      }
    }),
    updateSessionData: flow(function* updateSessionData(data: any) {
      self.appAccessToken = data.appAccessToken
      self.appRefreshToken = data.appRefreshToken
      self.appAccessTokenExpiry = data.appAccessTokenExpiry
      self.appRefreshTokenExpiry = data.appRefreshTokenExpiry
      self.appIdToken = data.appIdToken

      self.userRefreshToken = data.userRefreshToken
      self.userRefreshTokenExpiry = data.userRefreshTokenExpiry
      self.userAccessTokenExpiry = data.userAccessTokenExpiry
      self.userIdToken = data.userIdToken
      self.userAccessToken = data.userAccessToken
      self.jfsUserId = data.jfsUserId
      self.isVerified = data.isVerified
      self.emailId = data?.emailId
      self.isEmailLogin = data?.isEmailLogin
      const mobileNumber = RootStore.settings.metaData.mobileNumber
      setUsrAppRefreshParams(
        extendUserSession(mobileNumber, self.userAccessToken, self.userRefreshToken),
        HeaderTransformer,
        extendAppSession(self.appAccessToken, self.appRefreshToken),
        AppHeaderTransformer,
      )
      yield storeData('sessionData', JSON.stringify(self))

      window?.localStorage && window?.localStorage.setItem('sessionData', JSON.stringify(self))
    }),
    async removeMerchantDetailsFromStore() {
      if (isOsMobile()) {
        const merchantData = await AsyncStorage.removeItem('midData')
        return merchantData
        // return null
      } else {
        const merchData = window.localStorage.removeItem('merchantData')
        return merchData
      }
    },
  }))
  .views((self) => ({
    get getTokens() {
      return {
        appAccessToken: self.appAccessToken,
        appIdToken: self.appIdToken,
        userAccessToken: self.userAccessToken,
        userIdToken: self.userIdToken,
      }
    },
    getJfsUserId() {
      if (self.jfsUserId?.length < 2) {
        let jfsUserId
        if (isOsMobile()) {
          jfsUserId = getFromStore('jfsUserId')
        } else {
          jfsUserId = window?.localStorage.getItem('jfsUserId') ?? ''
        }
        if (jfsUserId?.length > 2) {
          return jfsUserId
        }
      } else {
        return self.jfsUserId
      }
      return ''
    },
    returnJfsUserIdAfterLogin() {
      return self?.jfsUserId
    },
  }))

const sessionDataV2 = Session.create({
  userAccessToken: '',
  userRefreshToken: '',
  userAccessTokenExpiry: -1,
  userRefreshTokenExpiry: -1,
  isVerified: false,
  lastLoginDate: '',
  appAccessToken: '',
  appIdToken: '',
  userIdToken: '',
  appRefreshToken: '',
  appAccessTokenExpiry: -1,
  appRefreshTokenExpiry: -1,
})

const sessionDataV21 = Session.create({
  userAccessToken: '',
  userRefreshToken: '',
  userAccessTokenExpiry: -1,
  userRefreshTokenExpiry: -1,
  isVerified: false,
  lastLoginDate: '',
  appAccessToken: '',
  appIdToken: '',
  userIdToken: '',
  appRefreshToken: '',
  appAccessTokenExpiry: -1,
  appRefreshTokenExpiry: -1,
})
export { Session, sessionDataV2, sessionDataV21 }
export type SessionV2 = Instance<typeof Session>
